var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user interface/cross"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1304 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29297 19.293L19.293 3.29297L20.7072 4.70718L4.70718 20.7072L3.29297 19.293Z",
    fill: "#092724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1304 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.707 19.293L4.70703 3.29297L3.29282 4.70718L19.2928 20.7072L20.707 19.293Z",
    fill: "#092724"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.fb252b40a7e4c60aed8b024ee26190eb.svg";